import React, { createContext, useContext, useState, useCallback } from "react";

// Lightweight i18n. French is the primary/complete dictionary; other languages
// fall back to French keys so the architecture supports EN/AR/ES later.
const fr = {
  "app.name": "ActiPilote",
  "app.tagline": "Pilotez toute votre activité.",
  // Auth
  "auth.login.title": "Connexion",
  "auth.login.subtitle": "Accédez à votre espace de gestion",
  "auth.email": "Adresse e-mail",
  "auth.password": "Mot de passe",
  "auth.remember": "Se souvenir de moi",
  "auth.forgot": "Mot de passe oublié ?",
  "auth.login.cta": "Se connecter",
  "auth.google": "Continuer avec Google",
  "auth.or": "ou",
  "auth.no_account": "Pas encore de compte ?",
  "auth.register": "Créer un compte",
  "auth.have_account": "Déjà un compte ?",
  "auth.register.title": "Créer votre compte",
  "auth.register.subtitle": "Commencez à piloter votre activité en quelques minutes",
  "auth.name": "Nom complet",
  "auth.register.cta": "Créer mon compte",
  "auth.forgot.title": "Mot de passe oublié",
  "auth.forgot.subtitle": "Recevez un lien de réinitialisation par e-mail",
  "auth.forgot.cta": "Envoyer le lien",
  "auth.forgot.sent": "Si un compte existe, un e-mail de réinitialisation vient d'être envoyé.",
  "auth.back_login": "Retour à la connexion",
  "auth.reset.title": "Nouveau mot de passe",
  "auth.reset.subtitle": "Choisissez un mot de passe sécurisé",
  "auth.reset.cta": "Réinitialiser",
  "auth.reset.done": "Mot de passe mis à jour. Vous pouvez vous connecter.",
  // Nav
  "nav.dashboard": "Tableau de bord",
  "nav.support": "Support",
  "nav.planning": "Planning",
  "nav.reservations": "Réservations",
  "nav.clients": "Clients",
  "nav.caisse": "Caisse",
  "nav.depenses": "Dépenses",
  "nav.operations": "Opérations",
  "nav.flotte": "Flotte",
  "nav.maintenance": "Maintenance",
  "nav.equipe": "Équipe",
  "nav.partenaires": "Partenaires",
  "nav.statistiques": "Statistiques",
  "nav.prestations": "Prestations",
  "nav.parametres": "Paramètres",
  // Dashboard
  "dash.greeting": "Bonjour",
  "dash.today_activity": "Activité aujourd'hui",
  "dash.revenue_evolution": "Évolution du chiffre d'affaires",
  "dash.distribution": "Répartition du chiffre d'affaires",
  "dash.alerts": "Alertes",
  "dash.quick.reservation": "Nouvelle réservation",
  "dash.quick.expense": "Ajouter une dépense",
  "dash.quick.client": "Ajouter un client",
  "period.aujourdhui": "Aujourd'hui",
  "period.hier": "Hier",
  "period.7j": "7 jours",
  "period.ce_mois": "Ce mois",
  "period.mois_dernier": "Mois dernier",
  "period.personnalise": "Personnalisé",
};

const dictionaries = { fr, en: {}, ar: {}, es: {} };

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");
  const changeLang = useCallback((l) => {
    localStorage.setItem("lang", l);
    setLang(l);
  }, []);
  const t = useCallback(
    (key) => (dictionaries[lang] && dictionaries[lang][key]) || fr[key] || key,
    [lang]
  );
  return (
    <I18nContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useT() {
  const ctx = useContext(I18nContext);
  if (!ctx) return { t: (k) => fr[k] || k, lang: "fr", changeLang: () => {} };
  return ctx;
}
